import config from '../../constants/endpoints'
import axios from 'axios'
import getHeaders from '../helpers/headers'

const {
  endpoints: { newAccount },
} = config

export const validateFields = (body) =>
  axios({
    url: newAccount.validateSignup,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

export const signupCompany = (body) =>
  axios({
    url: newAccount.signupCompany,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

export const signupOperator = (body) =>
  axios({
    url: newAccount.signupOperator,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

export const signupVerify = (body) =>
  axios({
    url: newAccount.verify,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

// change email
export const signupChangeEmail = (body) =>
  axios({
    url: newAccount.changeEmail,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

// send link change password
export const emailChangePassword = (body) =>
  axios({
    url: newAccount.sendEmailPassword,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

export const changePassword = (body) =>
  axios({
    url: newAccount.changePassword,
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })

export const checkTokenOperator = (token) =>
  axios({
    url: newAccount.checkTokenOperator.replace(':token', token),
    method: 'post',
    headers: getHeaders(true),
    data: {},
  })

export const checkTokenPassword = (token) =>
  axios({
    url: newAccount.checkTokenPassword,
    method: 'post',
    headers: getHeaders(true),
    data: { token },
  })
